// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"3f4d312d","455":"f15a61cd","977":"dffe72fe"}[chunkId] + ".chunk.js";
};